module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av428-d5a76120730b3593110dc15465553226.jpg";